<template>
    <app-perfect-scrollbar style="height: 90vh; width: 100%;">
        <div id="changelog">
        </div>
    </app-perfect-scrollbar>
</template>

<script>
    import showdown from 'showdown' 
    export default {
        mounted() {
            let defaultOptions = showdown.getDefaultOptions()
            let converter = new showdown.Converter({ 
                emoji: true,
                openLinksInNewWindow: true,
                tables: true,
                simplifiedAutoLink: true,
                customizedHeaderId: true,
                noHeaderId: true,
                tasklists: true,
                disableForced4SpacesIndentedSublists: true,
                metadata: true
            })
            let html = converter.makeHtml(require('../../../../CHANGELOG.md'))
            document.querySelector('#changelog').innerHTML = html
        }
    }
</script>

<style>
    #changelog {
        padding: 100px;
    }
    #changelog ul {
        padding-left: 20px;
    }
    #changelog ul li {
        padding-left: 0;
        list-style: disc;
        margin-top: 7px;
    }
    #changelog ul li img {
        margin-top: 7px;
        max-width: 700px;
    }
    #changelog ul li:first-child {
        margin-top: 0
    }

    #changelog h1:first-child {
        padding-top: 0;
        margin-top: 0;
        font-size: 16px;
        text-transform: uppercase;
    }

    #changelog h1 {
        color: var(--font-color--7)
    }

    #changelog h2 {
        color: var(--font-color--6)
    }

    #changelog h1, #changelog h1 a {
        font-size: 24px;
    }

    #changelog h2, #changelog h2 a {
        font-size: 18px;
        border-bottom: 1px solid var(--font-color--1);
    }

    #changelog h3, #changelog h3 a {
        font-size: 16px;
    }

    #changelog h1, #changelog h2, #changelog h3, #changelog h4, #changelog h5, #changelog h6,
    #changelog h1 a, #changelog h2 a, #changelog h3 a, #changelog h4 a, #changelog h5 a, #changelog h6 a {
        padding-bottom: 5px;
        font-weight: 600;
        margin-bottom: 16px;
        margin-top: 24px;
    }


    #changelog blockquote, #changelog details, #changelog dl, #changelog ol, #changelog p, #changelog pre, #changelog table, #changelog ul {
        margin-bottom: 16px;
    }
</style>
